import React, { useContext, useEffect, useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import $ from "jquery";
import { Helmet } from "react-helmet";
import { AppContext } from "./store";
import { ActionType } from "../@types";

export const TealiumHandler: React.FunctionComponent = ({ children }) => {
  const { dispatch } = useContext(AppContext);
  const [insertUtag, setInsertUtag] = useState(false);
  const { feEnableTealium } = useFlags();

  useEffect(() => {
    if (feEnableTealium) {
      /* istanbul ignore next: built-in functionality */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.jQuery = $;
      /* istanbul ignore next: built-in functionality */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.$ = $;

      setInsertUtag(true);
    }
  }, [feEnableTealium]);

  useEffect(() => {
    if (insertUtag) {
      const regEx = /^(www|es|enrollmentcenter|plancompare|csr).medicare.gov/;
      const environment = regEx.test(window.location.hostname) ? "prod" : "dev";
      const scriptName = `//tags.tiqcdn.com/utag/cmsgov/medicare-www/${environment}/utag.js`;
      const script = document.createElement("script");
      script.src = scriptName;
      script.type = "text/javascript";
      script.async = true;
      script.onload = (): void => {
        dispatch({
          type: ActionType.SET_TEALIUM_LOADED,
          payload: true,
        });
      };
      document.body.appendChild(script);
    }
  }, [insertUtag]);

  const utag1 = "var utag_data; window.utag_cfg_ovrd = { noview: true };";

  return (
    <>
      {insertUtag && (
        <Helmet>
          <script type="text/javascript">{utag1}</script>
          <script
            type="text/javascript"
            defer
            src="//tags.tiqcdn.com/utag/cmsgov/medicare-www/prod/utag.sync.js"
          ></script>
        </Helmet>
      )}
      {insertUtag && (
        <span id="app-utag1" className="ds-u-display--none">
          Tealium Enabled
        </span>
      )}
      {children}
    </>
  );
};

export default TealiumHandler;
